import $ from "jquery";

function init() {
}

function getQueryStringFilters() {
    const filters = getFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    alert("Returning Filter " + filters)
    return filters;
}

function getFilters() {
    return {
        programId: $("#programId").val() || null,
        requestType: $("#selectRequestType").val() || null,
        siteId: $("#selectSite").val() || null,
        regionId: $("#selectRegion").val() || null,
        courseTypeId: $("#selectCourseType").val() || null,
        courseLengthId: $("#selectCourseLength").val() || null,
        courseEditionId: $("#selectCourseEdition").val() || null,
        startDate: $("#dateRangeStart").val() || null,
        endDate: $("#dateRangeEnd").val() || null,
    };
}

export const staffAuditReportFilters = {
    init: init,
    getFilters: getFilters,
    getQueryStringFilters: getQueryStringFilters
};